module.exports = __webpack_public_path__ + "img/127.6202fb7b.png";